import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { forkJoin, Observable, of, Subject } from 'rxjs';
// IMPORTAÇÕES CORRIGIDAS E ADICIONADAS PARA RXJS
import { catchError, takeUntil, retry, finalize, map } from 'rxjs/operators';
import Cropper from 'cropperjs';

import { AuthService } from '../../services/auth.service';
import { PerfilPromptService } from '../../services/bff-prompts-perfil/prompts-perfil.service';

@Component({
  selector: 'app-profile-update-modal',
  templateUrl: './profile-update-modal.component.html',
  styleUrls: ['./profile-update-modal.component.css'],
  providers: [MessageService]
})
export class ProfileUpdateModalComponent implements OnInit, OnDestroy {

  profileForm!: FormGroup;
  displayDialog: boolean = true;
  isLoading: boolean = false;

  @ViewChild('imageToCrop') imageToCropElementRef: ElementRef<HTMLImageElement> | undefined;
  @ViewChild('fileInput') fileInputRef: ElementRef<HTMLInputElement> | undefined;
  cropper: Cropper | null = null;
  isCropping: boolean = false;
  imagePreviewForCropper: string | ArrayBuffer | null = null;
  originalSelectedFileForCropper: File | null = null;

  imagePreview: string | ArrayBuffer = 'assets/imagem/placeholder-user.png';
  private selectedFileForUpload: Blob | null = null;
  fileError: string | null = null;

  private userId: number = 0;
  private userLogin: string = '';
  private initialUserDataFromAuth: any = null;
  private currentUserDataForStorage: any = {};

  private destroy$ = new Subject<void>();

  readonly MAX_FILE_SIZE_MB = 5;
  readonly MAX_FILE_SIZE_BYTES = this.MAX_FILE_SIZE_MB * 1024 * 1024;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private perfilPromptService: PerfilPromptService,
    private router: Router,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initialUserDataFromAuth = this.authService.getUserData();

    if (!this.initialUserDataFromAuth || !this.initialUserDataFromAuth.usuario_id || !this.initialUserDataFromAuth.usuario_login) {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Dados do usuário não encontrados.' });
      this.userId = 0; this.userLogin = '';
      this.initialUserDataFromAuth = {
        usuario_id: 0, usuario_login: '', usuario_frase: '', usuario_cessaodireitos: false,
        usuario_apelido: '', usuario_nome: '', usuario_email: '',
        usuario_base64_arqfoto: null, foto_url: null
      };
    } else {
        this.userId = this.initialUserDataFromAuth.usuario_id;
        this.userLogin = this.initialUserDataFromAuth.usuario_login;
    }

    if (this.initialUserDataFromAuth.usuario_base64_arqfoto) { this.imagePreview = `data:image/png;base64,${this.initialUserDataFromAuth.usuario_base64_arqfoto}`; }
    else if (this.initialUserDataFromAuth.foto_url) { this.imagePreview = this.initialUserDataFromAuth.foto_url; }
    else { this.imagePreview = 'assets/imagem/placeholder-user.png'; }

    this.profileForm = this.fb.group({
        apelido: [this.initialUserDataFromAuth.usuario_apelido || this.initialUserDataFromAuth.usuario_nome || '', Validators.required],
        email: [this.initialUserDataFromAuth.usuario_email || '', [Validators.required, Validators.email]],
        frase: [this.initialUserDataFromAuth.usuario_frase || ''],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(); this.destroy$.complete();
    if (this.cropper) this.cropper.destroy();
  }

  // GETTER 'f' CORRIGIDO
  get f(): { [key: string]: AbstractControl } | null {
    return this.profileForm ? this.profileForm.controls : null;
  }

  onFileSelectedFromInput(event: Event): void {
    const input = event.target as HTMLInputElement; this.fileError = null;
    if (input.files && input.files.length > 0) {
      const file = input.files[0]; this.originalSelectedFileForCropper = file;
      if (file.size > this.MAX_FILE_SIZE_BYTES) { /*...*/ return; }
      if (!file.type.startsWith('image/')) { /*...*/ return; }
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreviewForCropper = reader.result; this.isCropping = true;
        this.cdRef.detectChanges(); setTimeout(() => this.iniciarCropper(), 50);
      };
      reader.readAsDataURL(file);
    }
  }

  iniciarCropper(): void {
    if (this.cropper) this.cropper.destroy();
    if (this.imageToCropElementRef?.nativeElement) {
      this.cropper = new Cropper(this.imageToCropElementRef.nativeElement, {
        aspectRatio: 1, viewMode: 1, autoCropArea: 0.8, scalable: true,
        zoomable: true, cropBoxResizable: true, background: false,
        responsive: true, checkOrientation: false,
      });
    } else { this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível iniciar recorte.'}); this.isCropping = false; }
  }

  recortarImagem(): void {
    if (!this.cropper) return;
    const canvas = this.cropper.getCroppedCanvas({ width: 300, height: 300, imageSmoothingEnabled: true, imageSmoothingQuality: 'high' });
    if (!canvas) { this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível recortar.' }); return; }
    this.imagePreview = canvas.toDataURL('image/png');
    canvas.toBlob((blob) => {
      if (blob) { this.selectedFileForUpload = blob; this.fileError = null; }
      else { this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível processar imagem.' }); this.selectedFileForUpload = null; }
      this.cropper?.destroy(); this.cropper = null; this.isCropping = false;
      if (this.fileInputRef) this.fileInputRef.nativeElement.value = '';
    }, 'image/png');
  }

  cancelarRecorte(): void {
    if (this.cropper) this.cropper.destroy(); this.cropper = null; this.isCropping = false;
    this.imagePreviewForCropper = null; if (this.fileInputRef) this.fileInputRef.nativeElement.value = '';
    if (this.initialUserDataFromAuth.usuario_base64_arqfoto) { this.imagePreview = `data:image/png;base64,${this.initialUserDataFromAuth.usuario_base64_arqfoto}`; }
    else if (this.initialUserDataFromAuth.foto_url) { this.imagePreview = this.initialUserDataFromAuth.foto_url; }
    else { this.imagePreview = 'assets/imagem/placeholder-user.png'; }
    this.selectedFileForUpload = null;
  }

  // _prepareAvatarUpdateObs CORRIGIDO (implementação)
  private _prepareAvatarUpdateObs(): Observable<any> {
    if (!this.selectedFileForUpload) return of({ noChange: true, type: 'avatar' });
    if (!this.userLogin) return of({ error: true, type: 'avatar', details: 'Login do usuário não disponível' });
    const formData = new FormData(); formData.append('file', this.selectedFileForUpload, this.originalSelectedFileForCropper?.name || 'avatar.png');
    return this.perfilPromptService.editUserAvatar(this.userLogin, formData).pipe(
      retry(1),
      map((response: any) => ({ response, type: 'avatar', noChange: false })), // Adiciona tipo e map
      catchError(err => of({ error: true, type: 'avatar', details: err }))
    );
  }

  private _prepareTextDataUpdateObs(): Observable<any> {
    const formValues = this.profileForm.value;
    let hasTextChanged = false;
    if (formValues.apelido !== (this.initialUserDataFromAuth.usuario_apelido || this.initialUserDataFromAuth.usuario_nome)) hasTextChanged = true;
    if (formValues.email !== this.initialUserDataFromAuth.usuario_email) hasTextChanged = true;
    if (this.profileForm.get('frase') && formValues.frase !== (this.initialUserDataFromAuth.usuario_frase || '')) hasTextChanged = true;

    if (!hasTextChanged) return of({ noChange: true, type: 'textData' });
    if (!this.userId || !this.userLogin) return of({ error: true, type: 'textData', details: 'ID ou Login de usuário inválido' });

    const payload = {
        usuario_id: this.userId,
        usuario_login: (this.initialUserDataFromAuth.usuario_login === (this.initialUserDataFromAuth.usuario_apelido || this.initialUserDataFromAuth.usuario_nome) && formValues.apelido !== this.initialUserDataFromAuth.usuario_login)
                         ? formValues.apelido : this.initialUserDataFromAuth.usuario_login,
        usuario_apelido: formValues.apelido,
        usuario_email: formValues.email,
        usuario_frase: this.profileForm.get('frase') ? formValues.frase : this.initialUserDataFromAuth.usuario_frase || '',
        usuario_cessaodireitos: this.initialUserDataFromAuth.usuario_cessaodireitos === true
    };
    return this.perfilPromptService.editUser(
      payload.usuario_login, payload.usuario_email,
      payload.usuario_apelido, payload.usuario_frase
    ).pipe(
      retry(1),
      map((response: any) => ({ response, type: 'textData', noChange: false, sentPayload: payload })), // Adiciona tipo, map e sentPayload
      catchError(err => { console.error("Erro API editUser:", err); return of({ error: true, type: 'textData', details: err, sentPayload: payload }); })
    );
  }

  updateProfile(): void {
    if (this.profileForm.invalid) { /*...*/ return; }
    if (!this.userId || !this.userLogin) { /*...*/ return; }

    const formIsDirty = this.profileForm.dirty;
    const imageIsPending = !!this.selectedFileForUpload;
    if (!formIsDirty && !imageIsPending) { this.messageService.add({ severity: 'info', summary: 'Informação', detail: 'Nenhuma alteração para salvar.' }); this.navigateToPainel(); return; }

    this.isLoading = true; const updateCalls: Observable<any>[] = [];
    if (formIsDirty) { updateCalls.push(this._prepareTextDataUpdateObs()); }
    if (imageIsPending) { updateCalls.push(this._prepareAvatarUpdateObs()); }
    if (updateCalls.length === 0) { /*...*/ this.navigateToPainel(); return; }

    const formValuesForStorage = this.profileForm.value;
    const imageBase64ForStorage = (imageIsPending && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('data:image/')) ? this.imagePreview.split(',')[1] : null;

    forkJoin(updateCalls)
      .pipe(takeUntil(this.destroy$), finalize(() => this.isLoading = false))
      .subscribe(results => {
        let anyApiError = false;
        let textDataApiCallSucceeded = results.some(res => res && res.type === 'textData' && !res.error && !res.noChange);
        let avatarApiCallSucceeded = results.some(res => res && res.type === 'avatar' && !res.error && !res.noChange);
        let atLeastOneApiSuccessOrNoChange = results.every(res => res && !res.error);

        results.forEach(res => {
          if (res && res.error) {
            anyApiError = true;
            const type = res.type === 'avatar' ? 'Foto' : 'Dados do Perfil';
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: `Falha ao atualizar ${type}.` });
          }
        });

        if (!anyApiError && (formIsDirty || imageIsPending)) {
          try {
            const storedUserDataString = localStorage.getItem('userData');
            this.currentUserDataForStorage = storedUserDataString ? JSON.parse(storedUserDataString) : {};
            this.currentUserDataForStorage.usuario_id = this.userId || this.initialUserDataFromAuth.usuario_id;
            const originalLogin = this.initialUserDataFromAuth.usuario_login;
            const originalNameForLoginCheck = this.initialUserDataFromAuth.usuario_apelido || this.initialUserDataFromAuth.usuario_nome;
            this.currentUserDataForStorage.usuario_login = (originalLogin === originalNameForLoginCheck && formValuesForStorage.apelido !== originalLogin && this.profileForm.get('apelido')?.dirty) ? formValuesForStorage.apelido : originalLogin;
            this.currentUserDataForStorage.usuario_apelido = formValuesForStorage.apelido;
            this.currentUserDataForStorage.usuario_email = formValuesForStorage.email;
            this.currentUserDataForStorage.usuario_frase = this.profileForm.contains('frase') ? formValuesForStorage.frase : (this.currentUserDataForStorage.usuario_frase || this.initialUserDataFromAuth.usuario_frase || '');
            this.currentUserDataForStorage.usuario_cessaodireitos = this.initialUserDataFromAuth.usuario_cessaodireitos === true;

            const avatarResult = results.find(r => r && r.type === 'avatar');
            if (imageIsPending && avatarResult && !avatarResult.error && imageBase64ForStorage) {
              this.currentUserDataForStorage.usuario_base64_arqfoto = imageBase64ForStorage;
              this.currentUserDataForStorage.usuario_id_arqfoto = null;
              this.currentUserDataForStorage.usuario_nm_arqfoto = null;
              this.currentUserDataForStorage.usuario_ext_arqfoto = null;
            } else if (!imageIsPending && this.initialUserDataFromAuth.usuario_base64_arqfoto){
              this.currentUserDataForStorage.usuario_base64_arqfoto = this.initialUserDataFromAuth.usuario_base64_arqfoto;
            } else if (imageIsPending && (!avatarResult || avatarResult.error)) {
              this.currentUserDataForStorage.usuario_base64_arqfoto = this.currentUserDataForStorage.usuario_base64_arqfoto || this.initialUserDataFromAuth.usuario_base64_arqfoto;
            }

            localStorage.setItem('userData', JSON.stringify(this.currentUserDataForStorage));
            this.authService.syncUserDataFromStorage();
            if (atLeastOneApiSuccessOrNoChange || (formIsDirty || imageIsPending) ) {
                 this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Perfil atualizado!' });
                 sessionStorage.setItem('refreshProfilePage', 'true');
            }

            this.profileForm.reset(formValuesForStorage, { emitEvent: false });
            this.selectedFileForUpload = null;
          } catch (e) {
              console.error("Erro ao processar ou salvar dados no localStorage:", e);
              this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao salvar dados localmente.' });
              anyApiError = true;
          }
        }
        if (!anyApiError) { this.navigateToPainel(); }
      });
  }

  private navigateToPainel(): void {
    this.displayDialog = false;
    this.router.navigate(['/painel']);
  }

  skipUpdate(): void {
    if (this.isCropping) this.cancelarRecorte();
    this.navigateToPainel();
  }
}
